import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';

import { BusinessState, DeliveryPeriodType } from '../../../models';

export function deleteFutureDeliveryPeriodReducerNew(
  state: BusinessState,
  { from }: UTCDeliveryPeriod,
  deliveryShopId: string,
): BusinessState {
  if (!from) {
    return state;
  }

  const fromJson = from;

  const deliveryPeriodsByShop = state.deliveryPeriods[deliveryShopId] ?? {};
  const deliveryPeriodsByType =
    deliveryPeriodsByShop[DeliveryPeriodType.Future] ?? {};

  const filteredDeliveryPeriods = (
    deliveryPeriodsByType.deliveryPeriods ?? []
  ).filter((deliveryPeriod) => deliveryPeriod !== fromJson);

  return {
    ...state,
    deliveryPeriods: {
      ...state.deliveryPeriods,
      [deliveryShopId]: {
        ...deliveryPeriodsByShop,
        [DeliveryPeriodType.Future]: {
          ...deliveryPeriodsByType,
          selectedDeliveryPeriod: filteredDeliveryPeriods[0] ?? null,
          deliveryPeriods: filteredDeliveryPeriods,
        },
      },
    },
  };
}
